import type { Key } from "react-aria-components";
import { ToggleButton, ToggleButtonGroup } from "@heroui/react";

interface SegmentedProps<T extends string> {
	options: readonly { id: T; label: string }[];
	value: T;
	onChange: (value: T) => void;
	size?: "sm" | "md";
	"aria-label": string;
	className?: string;
}

/**
 * Single-select segmented control (timeframes, ranges, filters) —
 * HeroUI ToggleButtonGroup with one option always selected.
 */
export function Segmented<T extends string>({
	options,
	value,
	onChange,
	size = "sm",
	className,
	...rest
}: SegmentedProps<T>) {
	return (
		<ToggleButtonGroup
			aria-label={rest["aria-label"]}
			selectionMode="single"
			disallowEmptySelection
			size={size}
			className={className}
			selectedKeys={new Set<Key>([value])}
			onSelectionChange={(keys) => {
				const next = [...keys][0];
				if (next != null) onChange(String(next) as T);
			}}
		>
			{options.map((o, i) => (
				<ToggleButton key={o.id} id={o.id} className="num">
					{i > 0 && <ToggleButtonGroup.Separator />}
					{o.label}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	);
}
